import { Collection } from 'modules/core/lib/mobx-rest'

import TaskFile from 'modules/tasks/store/models/TaskFile'

class TasksFiles extends Collection<TaskFile> {
  get cacheKey(): string {
    return 'tasksFiles'
  }

  model() {
    return TaskFile
  }

  bulkCreate(data: Record<string, unknown>): Promise<unknown> {
    return this.rpc('bulk_create', data)
  }
}

const singleton: TasksFiles = new TasksFiles()

export { TasksFiles }

export default singleton
